import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageMessage } from '../shared/page-messages/page-message.model';
import { convertServerError } from '../shared/pipes/convert-server-error.pipe';
import { SupportMaterialsService } from '../shared/services/support-materials.service';

@Component({
  selector: 'app-download-resource-file',
  templateUrl: './download-resource-file.component.html',
  styleUrls: [ './download-resource-file.component.scss' ],
  standalone: false
})
export class DownloadResourceFileComponent implements OnInit {
  public pageMessage: PageMessage = null;
  public fileAvailable = false;
  public fileId: number = null;
  public downloadMessage: string;
  public fileName: string;

  public constructor(
    private route: ActivatedRoute,
    private service: SupportMaterialsService
  ) { }

  public ngOnInit(): void {
    const { fileId } = this.route.snapshot.params;
    this.fileId = Number(fileId);

    this.getAndOpenFile();
  }

  /**
   * gets the download url and then calls the window open method to download the file
   * @param ev Optional Mouse Event (this can be called via link in the template, but also on ngOnInit)
   */
  public getAndOpenFile(ev?: MouseEvent): void {
    if (ev) {
      ev.preventDefault();
    }
    this.service.getDownloadUrl(this.fileId).pipe(
      convertServerError()
    ).subscribe({
      next: (val) => {
        this.performDownloadAction(val.url, val.fileName);
      },
      error: (e: PageMessage[]) => {
        this.handleServerError(e);
      }
    });
  }

  /**
   * This will attempt to open a window and download the file.
   * It will attempt check if there is a popup blocker
   * @param url the azure url to download the file
   * @param fileName: string
   */
  public performDownloadAction(url: string, fileName: string): void {
    this.fileAvailable = true;
    this.fileName = fileName;
    const newWindow = window.open(url);

    /**
     * Check if there is a pop-up blocker
     */
    if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
      this.downloadMessage = 'message.DownloadingExternalFilePopUpBlocked';
    } else {
      this.downloadMessage = 'message.DownloadingExternalFile';
    }
  }
  
  /**
   * Handles errors returned by the server.
   * @param errors Server errors that have been transformed vai the convertServerError pipe
   */
  public handleServerError(errors: PageMessage[]): void {
    this.pageMessage = errors[ 0 ];
  }
}
